import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import UserMaintaneneceContent from "./UserMaintaneneceContent";
import ExcelDownload from "./ExcelDownload";
import FeedbackTable from "./FeedbackTable";
import WelcomeNameContainer from "../LaunchComponent/WelcomeNameContainer";
import "./AdminTable.css";
import TrackDetails from "./TrackDetails";
import axios from "axios";
import { baseURL } from "../Constant";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Certificates from "./certificate/Certificates";

export const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#7500C0"),
  backgroundColor: "#7500C0",
  "&:hover": {
    backgroundColor: "#7500C0",
    color: "#fff",
  },
}));

const AdminTable = () => {
  const [value, setValue] = React.useState("1");
  const [trackDetails,setTrackDetails]= React.useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(()=>{
    
    const fetchTrackData=async()=>{
      try{
        const response= await axios.get(`${baseURL}/track-details`);
       if(response.status===200) setTrackDetails(response.data);
      }catch(err){
        console.log(err);
      }
    }
    
    fetchTrackData();
  },[]);

  return (
    <>
      <div className="admintabs-container">
        {/* <Box sx={{ width: "95%", typography: "body1", margin: "auto" }}> */}
        <WelcomeNameContainer currentComp={"admin"} />
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              sx={{
                // borderBottom: '2px solid transparent',
                // '& .Mui-selected': {
                //   borderBottom: '2px solid #022278'
                // }
                backgroundColor: "f0f4ff",
              }}
            >
              <Tab
                label="User Maintenance"
                value="1"
                sx={{
                  textTransform: "capitalize",
                  "&.Mui-selected": {
                    color: "#022278",
                    fontWeight: 600,
                  },
                  color: "#000",
                }}
              />

              <Box
                sx={{
                  width: "0.5px",
                  height: "24px",
                  backgroundColor: "gray",
                  mx: 1,
                  marginTop: "12px",
                }}
              />
               <Tab
                label="Track Details"
                value="2"
                sx={{
                  textTransform: "capitalize",
                  "&.Mui-selected": {
                    color: "#022278",
                    fontWeight: 600,
                  },
                  color: "#000",
                  
                }}
                className="powerBiTab"
              />
               <Box
                sx={{
                  width: "0.5px",
                  height: "24px",
                  backgroundColor: "gray",
                  mx: 1,
                  marginTop: "12px",
                }}
              />

              <Tab
                label="View Feedback"
                value="3"
                sx={{
                  textTransform: "capitalize",
                  "&.Mui-selected": {
                    color: "#022278",
                    fontWeight: 600,
                  },
                  color: "#000",
                }}
              />

              <Box
                sx={{
                  width: "0.5px",
                  height: "24px",
                  backgroundColor: "gray",
                  mx: 1,
                  marginTop: "12px",
                }}
              />

              <Tab
                label="Data for Power BI"
                value="4"
                sx={{
                  textTransform: "capitalize",
                  "&.Mui-selected": {
                    color: "#022278",
                    fontWeight: 600,
                  },
                  color: "#000",
                  
                }}
                className="powerBiTab"
              />

              <Box
                sx={{
                  width: "0.5px",
                  height: "24px",
                  backgroundColor: "gray",
                  mx: 1,
                  marginTop: "12px",
                }}
              />

              <Tab
                label="Certificates"
                value="5"
                sx={{
                  textTransform: "capitalize",
                  "&.Mui-selected": {
                    color: "#022278",
                    fontWeight: 600,
                  },
                  color: "#000",
                  
                }}
                className="powerBiTab"
              />
            </TabList>
          </Box>
          <TabPanel value="1">
            <UserMaintaneneceContent/>
          </TabPanel>
          <TabPanel value="2">
            <TrackDetails/>
          </TabPanel>
          <TabPanel value="3">
            <FeedbackTable />
          </TabPanel>
          <TabPanel value="4">
            {" "}
            <ExcelDownload />{" "}
          </TabPanel>
          <TabPanel value="5">
            {" "}
            <Certificates />
          </TabPanel>
        </TabContext>
        {/* </Box> */}
      </div>
    </>
  );
};

export default AdminTable;
